"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaTypes = exports.headerNames = exports.defaultMessages = exports.default = exports.bodyTypes = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// The HttpClient is a singleton object that can be used to make ajax
// requests.
//
// Example:
//  import client from './httpClient';
//
//  login(email: string, password: string) {
//    return client.post(
//      'member/mem/v1/login',
//      { body: { email, password }, }
//    );
//  }
//
// There are 7 main methods:
// 1. client.get(path<string>, data<Data>)<Promise>;
// 2. client.post(path<string>, data<Data>)<Promise>;
// 3. client.put(path<string>, data<Data>)<Promise>;
// 4. client.del(path<string>, data<Data>)<Promise>;
// 5. client.path(path<string>, data<Data>)<Promise>;
// 6. client.getConfig()<Config>);
// 7. client.addInterceptor(interceptor<Interceptor>)<void>;
//
// There are a few properties as well
// 1. client.isRequesting<bool>
// 2. client.activeRequestCount<number>
//
// Data Types:
// - Config = { baseUrl<string>, headers<object>, credentials<string> }
//    Used when calling client.initialize(config)
// - Data = { body<object>, params<string|object>, cache<boolean>, headers<object> }
//    Used on any ajax request client.get(path, data)
// - Response = { body<object|string>, status<number>, headers<object> }
//    The response of any ajax request either as a success or error
// - Interceptor = { request<function>, requestError<function>, response<function>, responseError<function> }
//
var defaultMessages = {
  400: 'Invalid data sent',
  401: 'You are not logged in',
  403: 'You are not authorized',
  404: 'The endpoint for the request was not found',
  408: 'The request timed out',
  500: 'An unknown server error occurred',
  520: 'An unknown error occurred'
};
exports.defaultMessages = defaultMessages;
var headerNames = {
  apiAuthToken: 'X-AL-API-AuthToken',
  accept: 'Accept',
  contentType: 'Content-Type',
  contentLength: 'Content-Length'
};
exports.headerNames = headerNames;
var mediaTypes = {
  json: 'application/json',
  text: 'application/text',
  form: 'application/x-www-form-urlencoded',
  binary: 'application/octet-stream',
  multipart: 'multipart/form-data'
};
exports.mediaTypes = mediaTypes;
var bodyTypes = {
  json: 'json',
  form: 'form',
  text: 'text',
  binary: 'binary',
  multipart: 'multipart'
};
exports.bodyTypes = bodyTypes;

function buildMultipartFormBody(body) {
  if (!Array.isArray(body)) {
    throw new Error('type multipart expects body as an array');
  }

  var formData = new FormData();
  body.forEach(function (part) {
    var raw = part.data;
    var type = part.type || bodyTypes.text;
    var data = type === 'json' ? JSON.stringify(raw) : raw;
    formData.append(part.name, data);
  });
  return formData;
}

function encodeBody(type, body) {
  switch (type) {
    case bodyTypes.json:
      return JSON.stringify(body);

    case bodyTypes.form:
      return encodeURIComponent(JSON.stringify(body));

    case bodyTypes.multipart:
      return buildMultipartFormBody(body);

    default:
      return body;
  }
}

function buildRequest(path, data) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var method = data.method.toUpperCase() || 'GET'; // Get headers from "config", then overwrite with any from "data"

  var headers = _objectSpread(_objectSpread({}, config.headers || {}), data.headers || {}); // If "accepts" is not defined, then assume json


  if (!headers[headerNames.accept]) {
    headers[headerNames.accept] = mediaTypes.json;
  } // Check for query params, and if an object, then convert to a string


  var queryParams;

  if (data.params) {
    switch ((0, _typeof2.default)(data.params)) {
      case 'object':
        {
          var strings = [];
          Object.getOwnPropertyNames(data.params).forEach(function (param) {
            strings.push("".concat(encodeURIComponent(param), "=").concat(encodeURIComponent(data.params[param])));
          });
          queryParams = strings.join('&');
          break;
        }

      case 'string':
        {
          queryParams = data.params;
          break;
        }

      default:
        {
          throw new Error("Invalid params '".concat(JSON.stringify(data.params), "' of type '").concat((0, _typeof2.default)(data.params), "'"));
        }
    }
  } // Only attempt to add a body if this is not a "get" or a "head" request


  var body;

  if (data.body && method !== 'GET' && method !== 'HEAD') {
    var type = data.type;

    if (!type) {
      // If we dont know the type, but its a object, assume "json"; else "text"
      type = (0, _typeof2.default)(data.body) === 'object' ? bodyTypes.json : bodyTypes.text;
    }

    if (type !== bodyTypes.multipart) {
      headers[headerNames.contentType] = mediaTypes[type];
    }

    body = encodeBody(type, data.body);
  } // Get full path by looking for a baseUrl, then adding any query params


  var fullPath = config.baseUrl && !process.env.IS_BROWSER ? config.baseUrl.replace(/\/?$/, "".concat(path)) : path;

  if (queryParams) {
    fullPath += (queryParams[0] !== '?' ? '?' : '') + queryParams;
  }

  return new Request(fullPath, _objectSpread(_objectSpread({}, data), {
    method: method,
    headers: new Headers(headers),
    body: body,
    cache: data.cache || 'no-store'
  }));
}

function applyInterceptors(input, interceptors, successName, errorName) {
  var promise = Promise.resolve(input);

  var _iterator = _createForOfIteratorHelper(interceptors),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var interceptor = _step.value;
      var successHandler = interceptor[successName];
      var errorHandler = interceptor[errorName];
      promise = promise.then(successHandler && successHandler.bind(interceptor), errorHandler && errorHandler.bind(interceptor));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return promise;
}

function processRequest(request, interceptors) {
  return applyInterceptors(request, interceptors, 'request', 'requestError');
}

function processResponse(response, interceptors) {
  return applyInterceptors(response, interceptors, 'response', 'responseError');
}

function responseToResult() {
  return _responseToResult.apply(this, arguments);
}

function _responseToResult() {
  _responseToResult = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var response,
        result,
        _iterator2,
        _step2,
        pair,
        _iterator3,
        _step3,
        key,
        text,
        _args2 = arguments;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            response = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
            result = {
              status: response.status,
              headers: {}
            }; // Turn headers into an associative array

            if (!response.headers) {
              _context2.next = 22;
              break;
            }

            if (!response.headers.raw) {
              _context2.next = 7;
              break;
            }

            result.headers = _objectSpread({}, response.headers.raw);
            _context2.next = 22;
            break;

          case 7:
            if (!response.headers.entries) {
              _context2.next = 12;
              break;
            }

            _iterator2 = _createForOfIteratorHelper(response.headers.entries());

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                pair = _step2.value;
                result.headers[pair[0]] = pair[1];
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            _context2.next = 22;
            break;

          case 12:
            if (!response.headers.forEach) {
              _context2.next = 16;
              break;
            }

            response.headers.forEach(function (value, key) {
              result.headers[key] = value;
            });
            _context2.next = 22;
            break;

          case 16:
            if (!response.headers.keys) {
              _context2.next = 21;
              break;
            }

            _iterator3 = _createForOfIteratorHelper(response.headers.keys());

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                key = _step3.value;
                result.headers[key] = response.headers.get(key);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            _context2.next = 22;
            break;

          case 21:
            throw new Error('Cannot iterate over response.headers');

          case 22:
            _context2.prev = 22;
            _context2.next = 25;
            return response.text();

          case 25:
            text = _context2.sent;
            _context2.next = 30;
            break;

          case 28:
            _context2.prev = 28;
            _context2.t0 = _context2["catch"](22);

          case 30:
            if (text) {
              try {
                // Check if its JSON, else assume text
                result.body = JSON.parse(text);
              } catch (e) {
                result.body = text;
              }
            }

            if (!result.body && defaultMessages[result.status]) {
              result.body = {
                message: defaultMessages[result.status]
              };
            }

            return _context2.abrupt("return", result);

          case 33:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[22, 28]]);
  }));
  return _responseToResult.apply(this, arguments);
}

var HttpClient = /*#__PURE__*/function () {
  function HttpClient() {
    var _this = this;

    (0, _classCallCheck2.default)(this, HttpClient);
    (0, _defineProperty2.default)(this, "_trackRequestStart", function () {
      _this.isRequesting = !!++_this.activeRequestCount;
    });
    (0, _defineProperty2.default)(this, "_trackRequestEnd", function () {
      _this.isRequesting = !! --_this.activeRequestCount;
    });
    (0, _defineProperty2.default)(this, "_trackRequestEndWith", function (promise) {
      var handle = _this._trackRequestEnd;
      promise.then(handle, handle);
      return promise;
    });
    this.config = {
      headers: {},
      credentials: 'include'
    };
    this.interceptors = [];
    this.activeRequestCount = 0;
    this.isRequesting = false;
  }

  (0, _createClass2.default)(HttpClient, [{
    key: "getConfig",
    value: function getConfig() {
      return this.config;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.config;
      this.config = _objectSpread(_objectSpread({}, this.config), config);
    }
  }, {
    key: "getResultsPromiseFromResponse",
    value: function getResultsPromiseFromResponse(res) {
      return responseToResult(res);
    }
  }, {
    key: "addInterceptor",
    value: function addInterceptor(interceptor) {
      this.interceptors.push(interceptor);
    }
  }, {
    key: "del",
    value: function del(path) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._fetch(path, _objectSpread(_objectSpread({}, data), {}, {
        method: 'DELETE'
      }));
    }
  }, {
    key: "get",
    value: function get(path) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._fetch(path, _objectSpread(_objectSpread({}, data), {}, {
        method: 'GET'
      }));
    }
  }, {
    key: "head",
    value: function head(path) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._fetch(path, _objectSpread(_objectSpread({}, data), {}, {
        method: 'HEAD'
      }));
    }
  }, {
    key: "post",
    value: function post(path) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._fetch(path, _objectSpread(_objectSpread({}, data), {}, {
        method: 'POST'
      }));
    }
  }, {
    key: "put",
    value: function put(path) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._fetch(path, _objectSpread(_objectSpread({}, data), {}, {
        method: 'PUT'
      }));
    }
  }, {
    key: "patch",
    value: function patch(path) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this._fetch(path, _objectSpread(_objectSpread({}, data), {}, {
        method: 'PATCH'
      }));
    }
  }, {
    key: "_fetch",
    value: function () {
      var _fetch2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path, data) {
        var _this2 = this;

        var request, result, response, promise;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                request = buildRequest(path, data, this.config);

                this._trackRequestStart();

                _context.next = 4;
                return processRequest(request, this.interceptors);

              case 4:
                result = _context.sent;
                response = null;

                if (!(result instanceof Response)) {
                  _context.next = 10;
                  break;
                }

                response = result;
                _context.next = 17;
                break;

              case 10:
                if (!(result instanceof Request)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 13;
                return fetch(result, {
                  credentials: data.credentials || this.config.credentials,
                  allowOnServer: data.allowOnServer
                });

              case 13:
                response = _context.sent;
                _context.next = 17;
                break;

              case 16:
                throw new Error("An invalid result was returned by the interceptor chain. Expected a Request or Response instance, but got [".concat(result, "]"));

              case 17:
                promise = new Promise(function (resolve, reject) {
                  processResponse(response, _this2.interceptors).then(function (res) {
                    var resultPromise = responseToResult(res).then(function (res2) {
                      if (res && res.status >= 300) {
                        return reject(res2);
                      } else {
                        return resolve(res2);
                      }
                    }).catch(function (error) {
                      return reject(error);
                    });
                  }).catch(function (res) {
                    var resultPromise = responseToResult(res).then(function (res2) {
                      return reject(res2);
                    }).catch(function (error) {
                      return reject(error);
                    });
                  });
                });
                return _context.abrupt("return", this._trackRequestEndWith(promise));

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _fetch(_x, _x2) {
        return _fetch2.apply(this, arguments);
      }

      return _fetch;
    }()
  }]);
  return HttpClient;
}();

var _default = new HttpClient();

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/httpClient/index.js
// module id = 245
// module chunks = 25